const swiper = new Swiper(".js-rmsCollectionSlider", {
  slidesPerView: 1.5,
  spaceBetween: 24,
  loop: false,
  centeredSlides: true,

  navigation: {
    nextEl: ".rms-collectionSlider__nav--next",
    prevEl: ".rms-collectionSlider__nav--prev",
  },

  breakpoints: {
    768: {
      centeredSlides: false,
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
});
